import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { UnifiedLoginGuard } from '@monorepo/services';
import { NavigationServiceGuard } from '../guard/navigation.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./app-shell/app-shell.module').then((m) => m.AppShellModule),
    canActivate: [NavigationServiceGuard, UnifiedLoginGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      preloadingStrategy: NoPreloading,
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
